import type { EventSourceMessage } from '@microsoft/fetch-event-source';

export class EventSourceLogger {
    private id: number;

    constructor() {
        this.id = generateDebugId();
    }

    private getNamespace() {
        return `[es-${this.id}]`;
    }

    connectionRequest(url: string) {
        console.log(`${this.getNamespace()} ⚪️ connection request\n${url}`);
    }

    connectionSuccess() {
        console.log(`${this.getNamespace()} 🟢 connection success`);
    }

    connectionError(err: unknown) {
        console.log(`${this.getNamespace()} 🔴 connection error`);
        console.error(err);
    }

    connectionFatalError(err: unknown) {
        console.log(`${this.getNamespace()} 🔴 connection fatal error`);
        console.error(err);
    }

    connectionRetry() {
        console.log(`${this.getNamespace()} 🟡 connection retry`);
    }

    connectionClosed() {
        console.log(`${this.getNamespace()} ⚪️ connection closed`);
    }

    connectionClosedFromServer() {
        console.log(`${this.getNamespace()} 🔴 connection closed from server`);
    }

    messageReceived(msg: EventSourceMessage) {
        console.log(`${this.getNamespace()} 📥 new message`);
        console.log(msg);
    }
}

const generateDebugId = (() => {
    let debugId = 1;

    return () => {
        return debugId++;
    };
})();
